import { useEffect, useMemo } from "react";
import localStorageService from "utils/localStorageService";
import useWorkspace from "utils/hooks/useWorkspace";
import { useLocation } from "react-router-dom";
import { WORKSPACE_STORAGE_KEY } from "@shared/common/constants";
import useSharedInitializeWorkspace from "@shared/features/workspaces/useSharedInitializeWorkspace";
import { checkQuickConnectRedirects } from "utils/routes";

const useInitializeWorkspace = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const localStorageWorkspace = localStorageService.getValue(
    WORKSPACE_STORAGE_KEY
  );
  const {
    workspace,
    setWorkspaceType,
    isPathInWorkspace,
    getValidWorkspacesByPath,
    realUser,
  } = useWorkspace();

  const isQuickConnectPath = useMemo(
    () => checkQuickConnectRedirects(location.pathname),
    [location.pathname]
  );
  useSharedInitializeWorkspace({
    localStorageWorkspace,
    allowAdminWorkspace: true,
    isQuickConnectPath,
  });

  useEffect(() => {
    if (workspace && !isPathInWorkspace(workspace, pathname)) {
      for (let workspaceType of getValidWorkspacesByPath(pathname)) {
        if (workspaceType !== workspace) {
          setWorkspaceType(workspaceType);
          return;
        }
      }
    }
  }, [workspace, pathname, realUser]);
};

export default useInitializeWorkspace;
